<div class="">

  <p-carousel 
    [value]="questions" 
    [numVisible]="1" 
    [numScroll]="1" [circular]="false" *ngIf="questions && questions.length > 0"
    (onPage)="onPageChanged($event)"
    #carousel
    >
    <ng-template let-question pTemplate="item">
        <div class="p-6">
            <div class="text-[32px] text-center font-semibold">{{question.title}}</div>

            <div class="mt-6 min-h-[400px] flex flex-col justify-center">
              <div *ngIf="question.type === 'number'" class="flex flex-col items-center">
                <div class="max-w-[560px]">
                  <div class="text-center mb-6">
                    <span class="text-[4em] text-accent">{{question.value || 1}}</span>
                  </div>
                  <p-slider [(ngModel)]="question.value" [step]="1" [min]="1" [max]="4"></p-slider>
                </div>
              </div>
  
              <div *ngIf="question.type === 'checkbox'">
                <div class="flex items-center justify-center flex-col">
                  <div class="border rounded w-[160px] h-[160px] border-gray-700 border-solid flex items-center justify-center">
                    <img [src]="question.image" alt="" *ngIf="question.image">
                    <span *ngIf="question.icon" class="material-symbols-outlined text-[64px]">
                      {{question.icon}}
                      </span>
                  </div>
                  <div class="mt-6">
                    <button class="btn btn-outline btn-secondary min-w-[120px]" (click)="next()">NO</button>
                    <button class="btn btn-outline btn-secondary min-w-[120px] ml-4" (click)="next()">YES</button>
                  </div>
                </div>
              </div>

              <div *ngIf="question.type === 'select'">
                <div *ngIf="question.options" class="">
                  <div class="max-w-[560px] flex flex-col gap-4 mx-auto">
                    <div *ngFor="let option of question.options" class="rounded border-2 border-solid border-secondary p-4 text-[24px] cursor-pointer" (click)="selectOption(question.options,option)"
                      [class.bg-secondary]="option.isSelected"
                      [class.text-white]="option.isSelected"
                    >
                      {{option.title}}
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="question.type === 'date'">
                <p-calendar class="max-w-full" [inline]="true" [showWeek]="true"></p-calendar>
              </div>
            </div>
        </div>
    </ng-template>
</p-carousel>

<div class="flex">
  <div *ngIf="currentQuestion > 0">
    <button class="btn" (click)="prev()">
      <span class="material-symbols-outlined mr-4">keyboard_backspace</span> Back</button>
  </div>
  <div class="flex-1">

  </div>
  <button *ngIf="isLastPage()" class="btn btn-primary min-w-[200px]" (click)="search()">Search</button>
  <button *ngIf="!isLastPage()" class="btn btn-primary min-w-[200px]" (click)="next()">Next</button>
</div>
</div>